import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { signOut } from 'firebase/auth';
import { auth } from 'utils/config/firebase';
import {
    BASE_URL,
    PROMPT_BUILDER,
    PROMPT_BUILDER_URL,
    JOB_ORDER,
    JOB_ORDER_BASE_URL,
} from './config';

export const createRequest = (type?: string | undefined) => {
    let baseURL: string | undefined = '';
    switch (type) {
        case 'test':
            baseURL = 'http://localhost:3001';
            break;
        case PROMPT_BUILDER:
            baseURL = PROMPT_BUILDER_URL;
            break;
        case JOB_ORDER:
            baseURL = JOB_ORDER_BASE_URL;
            break;
        default:
            baseURL = BASE_URL;
    }

    const request = axios.create({
        baseURL,
    });

    request.interceptors.request.use(onRequestFullfiled, (error) => Promise.reject(error));
    request.interceptors.response.use((response) => response, handleAxiosResponseError);

    return request;
};

async function onRequestFullfiled(config: InternalAxiosRequestConfig) {
    const id_token = await auth?.currentUser?.getIdToken();
    if (id_token) {
        if (!config?.headers) {
            throw new Error(`Expected 'config' and 'config.headers' not to be undefined`);
        }
        config.headers.Authorization = 'Bearer ' + id_token;
    }

    // Set Content-Type: application/json only if not sending FormData
    if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json';
    }

    return config;
}

// @TODO: uncomment when 401 from OAuth is handled properly
async function handleAxiosResponseError(error: AxiosError) {
    if (error?.response?.status === 401) {
        signOut(auth);
        window.location.pathname = '/sign-in';
    }
    return Promise.reject(error);
}

export const request = createRequest();
export const requestPromptBuilder = createRequest(PROMPT_BUILDER);
export const requestOrder = createRequest(JOB_ORDER);
